import {
	Accordion,
	Flex,
	Rte,
	Text,
	READABLE_LINE_MAX_WIDTH,
} from "@capioweb/ui-components"
import React from "react"
import { createMarkup } from "../../utils"

interface TermsAccordionProps {
	title: string
	body: string
}

export const TermsAccordion: React.FC<TermsAccordionProps> = ({
	title,
	body,
}) => {
	return (
		<Flex w={1} flexDirection="column">
			<Accordion>
				<Accordion.Header id="terms">
					<Text variant={"headline-3"} mb={0}>
						{title}
					</Text>
				</Accordion.Header>
				<Accordion.Panel id="terms">
					<Flex p={3} maxw={READABLE_LINE_MAX_WIDTH}>
						<Rte>
							{/* Needs to be Text component for font styling,
							we don't have control over formatting of `body` */}
							<Text dangerouslySetInnerHTML={createMarkup(body)}></Text>
						</Rte>
					</Flex>
				</Accordion.Panel>
			</Accordion>
		</Flex>
	)
}
